import withNavigate from "../../../routes/withNavigate";
import HourlySlotsContainer from "./HourlySlotsContainer.jsx";
import HourlySlotsStore from "./HourlySlotsStore";

export default HourlySlotsStore(withNavigate(HourlySlotsContainer));